import {
  createFetcher,
  HTTPError,
  withBaseUrl,
  // withCredentials,
  withHeaders,
  // withLanguage,
  withVersion,
} from '@nvision/services/fetcher';

import { ENV_VARS } from '@/env';
import { getLocalTimeZone } from '@/utils/date';

import { withAuth, withObsoleteEndpointLogger, withSelectedCompanyId } from './options';

export const fetcher = createFetcher(
  withBaseUrl(`${ENV_VARS.REACT_APP_API_URL}/api`),
  // withCredentials(),
  withVersion(() => ENV_VARS.VERSION),
  // withLanguage(() => getLocale()),
  withHeaders({
    Accept: 'application/json',
    'X-Time-Zone': getLocalTimeZone(),
  }),
  withSelectedCompanyId(),
  withAuth(),
  withObsoleteEndpointLogger(),
);

// Example of usage
// const usersApi = fetcher.extend(({ prefixUrl }) => ({ prefixUrl: `${prefixUrl}/users` }));

// api/users/$current

// export const fetchUserInfo = async ({ signal }: { signal?: AbortController['signal'] } = {}) => {
//   try {
//     return await usersApi.get('$current', { signal }).json(userInfoApiSchema);
//   } catch (error) {
//     if (error instanceof HTTPError) {
//       console.error(`Error: ${error.response.status}`);
//     }
//     throw error;
//   }
// };
export { HTTPError };
